import { render, staticRenderFns } from "./compareMotorcylce.vue?vue&type=template&id=7bd5e50b&"
import script from "./compareMotorcylce.vue?vue&type=script&lang=ts&"
export * from "./compareMotorcylce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports